module.exports = __webpack_public_path__ + "static/media/shipbob.d30fd7d8.png";